<template>
  <div class="list-container">
    <!-- 个人站运营报表 -->

    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>

    <div class="list-content-div" style="display: flex; flex-direction: column">
      <div class="list-header-title-div">个人站运营报表</div>

      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex" style="align-items: center;width: 100%;">
            <div class="query-title-div">时间筛选</div>
            <div class="query-inputs-div flex-1" style="max-width: 400px;">
              <el-date-picker v-model="dateRange" style="width: 100%" type="daterange" range-separator="~"
                start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange" value-format="yyyy-MM-dd"
                format="yyyy-MM-dd" size="small" :picker-options="pickerOptions" :clearable="false" />
            </div>
            <div class="query-buttons-div" style="margin-left: 20px; flex-shrink: 0; display: flex; gap: 8px;">
              <button class="common-bg-button" @click="handleDateChange">
                查 询
              </button>
              <button class="common-empty-button" @click="setCurrentMonthRange">重 置</button>
            </div>
          </div>
        </template>
      </ZD-list-querys>

      <!-- 日历展示区域 -->
      <div class="calendar-grid" v-if="calendarDays.length > 0">

        <div style="font-size: 16px; font-weight: bolder; margin: 16px 0;">
          {{ selectYear }} 年 {{ selectMonth }} 月
        </div>

        <!-- 星期标题 -->
        <div class="week-header">
          <div v-for="day in weekDays" :key="day" class="week-day-header">
            {{ day }}
          </div>
        </div>

        <!-- 日历网格 -->
        <div class="calendar-body">
          <div v-for="(day, index) in calendarDays" :key="index">
            <el-popover v-if="day.isSelected && day.shareOrderCount !== ''" placement="right" width="260"
              trigger="hover">
              <div class="popover-content">
                <div class="popover-title">{{ day.formattedDate }} 数据详情：</div>
                <div v-for="(item, idx) in getDetailItems(day)" :key="idx"
                  :class="['detail-item', { 'detail-item-sub': item.isSub }]">
                  <span class="detail-label">{{ item.label }}：</span>
                  <span class="detail-value">{{ item.value }}</span>
                </div>
              </div>
              <div slot="reference" :class="getDayClasses(day)">
                <div class="day-number">{{ day.date.getDate() }}</div>
                <div class="day-stats" v-if="day.isSelected">
                  <div class="day-stat-item">
                    <span class="stat-label">订单数：</span>
                    <span class="stat-value">{{ day.shareOrderCount || '-' }}</span>
                  </div>
                  <div class="day-stat-item">
                    <span class="stat-label">共享金额：</span>
                    <span class="stat-value">{{ formatMoney(day.shareMoneyCount) }}</span>
                  </div>
                </div>
              </div>
            </el-popover>
            <div v-else :class="getDayClasses(day)">
              <div class="day-number">{{ day.date.getDate() }}</div>
              <div class="day-stats" v-if="day.isSelected">
                <div class="day-stat-item">
                  <span class="stat-label">订单数：</span>
                  <span class="stat-value">{{ day.shareOrderCount || '-' }}</span>
                </div>
                <div class="day-stat-item">
                  <span class="stat-label">共享金额：</span>
                  <span class="stat-value">{{ formatMoney(day.shareMoneyCount) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 数据说明 -->
      <div class="data-description" v-if="calendarDays.length > 0">
        <div class="description-title">数据说明</div>
        <div class="description-grid">
          <div v-for="(item, index) in descriptionItems" :key="index" class="description-item">
            <div :class="['description-dot', item.color]"></div>
            <div class="description-content">
              <div class="description-title-text">{{ item.title }}</div>
              <div class="description-text">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      pagination: pageConfig.pagination,

      dateRange: [],
      queryInfo: {},
      selectYear: '',
      selectMonth: '',
      calendarDays: [],
      weekDays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      descriptionItems: [
        { title: '共享开关安装数', desc: '统计共享开关设备当天的绑定设备总数', color: 'blue' },
        { title: '当日首次开通数据', desc: '根据开关设备列表开通共享的时间，统计当天的开通数据', color: 'green' },
        { title: '私桩共享设备数', desc: '统计开关设备列表，当天有过共享状态的设备数', color: 'yellow' },
        { title: '私桩共享设备类型数（开关，桩）', desc: '统计开关设备列表，当天有过共享状态的设备数，分别记录设备列表和充电桩列表的设备数', color: 'purple' },
        { title: '使用共享充电的人数', desc: '当日使用共享充电服务的用户总数', color: 'red' },
        { title: '共享订单', desc: '统计当天私桩共享充电已关闭累计订单数', color: 'blue-light' },
        { title: '共享金额', desc: '统计当天私桩共享充电已关闭订单的累计用户实付金额', color: 'pink' },
        { title: '服务费收入', desc: '统计当天私桩共享充电已关闭订单的累计平台服务费', color: 'teal' },
      ],

      timeOptionRange: '',
      pickerOptions: {
        onPick: time => {
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: time => {
          const timeOptionRange = this.timeOptionRange;
          const secondNum = 60 * 60 * 24 * 30 * 1000;
          if (timeOptionRange) {
            return (time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum);
          }
          return false;
        }
      },

    };
  },
  mounted() {
    this.setCurrentMonthRange();
  },
  methods: {
    // 计算并回填当前月份起止
    setCurrentMonthRange() {
      this.dateRange = [
        this.getCurrentMonthFirst(),
        this.getCurrentMonthLast(),
      ];

      const text = this.dateRange[0]
      const arr = text.split("-")
      this.selectYear = arr[0]
      this.selectMonth = arr[1]

      this.handleDateChange();
    },
    getCurrentMonthFirst() {
      const date = new Date();
      date.setDate(1); // 设置为当月第一天
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${date.getFullYear()}-${month}-${day}`;
    },
    getCurrentMonthLast() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const lastDay = new Date(year, date.getMonth() + 1, 0).getDate();
      return `${year}-${month}-${lastDay}`;
    },
    handleDateChange() {
      let _ = this;
      if (_.dateRange && _.dateRange.length === 2) {
        _.queryInfo = {
          startDate: _.dateRange[0],
          endDate: _.dateRange[1],
        };
        // 更新年月显示
        const arr = _.dateRange[0].split("-");
        _.selectYear = arr[0];
        _.selectMonth = arr[1];
        _.generateCalendar();
      } else {
        _.calendarDays = [];
      }
    },

    generateCalendar() {
      let _ = this;
      if (!_.dateRange || _.dateRange.length !== 2) {
        _.calendarDays = [];
        return;
      }

      if (!_.queryInfo.startDate || !_.queryInfo.endDate) {
        _.calendarDays = [];
        return;
      }

      _.$H.post(_, _.$A.digitization.getOperationReport, _.queryInfo).then((res) => {
        const list = res.data.data || [];

        const startDate = new Date(_.dateRange[0]);
        const endDate = new Date(_.dateRange[1]);

        // 获取日历的开始和结束日期（包含前后补全的日期）
        const calendarStart = _.getCalendarStart(startDate);
        const calendarEnd = _.getCalendarEnd(endDate);

        const days = [];
        let currentDate = new Date(calendarStart);

        while (currentDate <= calendarEnd) {
          const flag = _.formatDate(currentDate);
          const index = list.findIndex(item => item.day === flag);

          days.push({
            date: new Date(currentDate),
            formattedDate: _.formatDate(currentDate),
            isSelected: currentDate >= startDate && currentDate <= endDate,
            isToday: _.isToday(currentDate),
            otherMonth: currentDate < startDate || currentDate > endDate,

            id: index >= 0 ? list[index].id : '',
            chargeLockBindCount: index >= 0 ? list[index].chargeLockBindCount : '',
            dayOpenLockCount: index >= 0 ? list[index].dayOpenLockCount : '',
            shareDeviceTotalCount: index >= 0 ? list[index].shareDeviceTotalCount : '',
            sharePileCount: index >= 0 ? list[index].sharePileCount : '',
            shareLockCount: index >= 0 ? list[index].shareLockCount : '',
            openShareDeviceCount: index >= 0 ? list[index].openShareDeviceCount : '',
            openSharePileCount: index >= 0 ? list[index].openSharePileCount : '',
            openShareLockCount: index >= 0 ? list[index].openShareLockCount : '',
            useShareChargeCount: index >= 0 ? list[index].useShareChargeCount : '',
            shareOrderCount: index >= 0 ? list[index].shareOrderCount : '',
            shareMoneyCount: index >= 0 ? list[index].shareMoneyCount : '',
            serviceFeeCount: index >= 0 ? list[index].serviceFeeCount : '',
          });

          currentDate.setDate(currentDate.getDate() + 1);
        }

        _.calendarDays = days;
      }).catch((err) => {
        console.error('获取运营报表数据失败:', err);
        _.calendarDays = [];
      });
    },

    getCalendarStart(date) {
      // 获取日历开始日期（当前周的第一天）
      const d = new Date(date);
      const day = d.getDay();
      d.setDate(d.getDate() - day);
      return d;
    },

    getCalendarEnd(date) {
      // 获取日历结束日期（当前周的最后一天）
      const d = new Date(date);
      const day = d.getDay();
      d.setDate(d.getDate() + (6 - day));
      return d;
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    isToday(date) {
      const today = new Date();
      return date.toDateString() === today.toDateString();
    },

    formatMoney(value) {
      if (value === '' || value === null || value === undefined) {
        return '-';
      }
      const num = Number(value);
      if (isNaN(num)) {
        return '-';
      }
      // 格式化金额，添加千分位分隔符
      return '¥' + num.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },

    getDayClasses(day) {
      return [
        'calendar-day',
        {
          'selected': day.isSelected && day.shareOrderCount !== '',
          'today': day.isToday,
          'other-month': day.otherMonth
        }
      ];
    },

    getDetailItems(day) {
      return [
        { label: '共享开关绑定数', value: day.chargeLockBindCount || '-' },
        { label: '当日首次开通数据', value: day.dayOpenLockCount || '-' },
        { label: '当前累计私桩共享设备数', value: day.shareDeviceTotalCount || '-' },
        { label: '私桩共享设备（充电桩）数', value: day.sharePileCount || '-', isSub: true },
        { label: '私桩共享设备（共享开关）数', value: day.shareLockCount || '-', isSub: true },
        { label: '当日开启共享设备数', value: day.openShareDeviceCount || '-' },
        { label: '私桩共享设备（充电桩）数', value: day.openSharePileCount || '-', isSub: true },
        { label: '私桩共享设备（共享开关）数', value: day.openShareLockCount || '-', isSub: true },
        { label: '使用共享充电的人数', value: day.useShareChargeCount || '-' },
        { label: '共享订单数', value: day.shareOrderCount || '-' },
        { label: '共享金额', value: day.shareMoneyCount || '-' },
        { label: '服务费收入', value: day.serviceFeeCount || '-' },
      ];
    },

  },
};
</script>

<style scoped>
.calendar-container {
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.date-picker-wrapper {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.calendar-grid {
  width: 100%;
  flex: 1;
  overflow: hidden;
}

.week-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.week-day-header {
  padding: 15px 10px;
  text-align: center;
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}

.calendar-body {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
}

.calendar-day {
  background: #fff;
  padding: 12px 10px;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 8px;
  margin-right: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: relative;
}

.calendar-day:hover {
  background: #f0f0f0;
  border-color: #c24cd6;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
  z-index: 10;
}

.calendar-day.selected {
  background: #f3e5f5;
  border: 2px solid #c343da;
  box-shadow: 0 2px 8px rgba(156, 39, 176, 0.25);
}

.calendar-day.selected:hover {
  background: #e1bee7;
  border-color: #9c27b0;
  box-shadow: 0 4px 16px rgba(156, 39, 176, 0.35);
  transform: translateY(-2px);
}

.calendar-day.today {
  background: #fff3e0;
  border: 2px solid #ff9800;
  box-shadow: 0 2px 6px rgba(255, 152, 0, 0.2);
}

.calendar-day.today:hover {
  background: #ffe0b2;
  border-color: #f57c00;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);
  transform: translateY(-2px);
}

.calendar-day.today:hover {
  background: #ffe0b2;
  border-color: #f57c00;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);
  transform: translateY(-2px);
}

.calendar-day.other-month {
  background: #fafafa;
  color: #bdbdbd;
  opacity: 0.6;
}

.day-number {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #212121;
}

.day-stats {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  width: 100%;
  margin-top: auto;
}

.day-stat-item {
  display: flex;
  align-items: center;
  line-height: 1.6;
  word-break: break-word;
}

.stat-label {
  color: #757575;
  white-space: nowrap;
  flex-shrink: 0;
  font-size: 12px;
}

.stat-value {
  color: #212121;
  font-weight: 600;
  margin-left: 6px;
  flex: 1;
  font-size: 12px;
}

.day-info {
  font-size: 11px;
  color: #6c757d;
  transition: opacity 0.3s ease;
}

.stats {
  margin-top: 20px;
  text-align: center;
  color: #495057;
  font-size: 16px;
}

.stats p {
  margin: 5px 0;
}

.popover-content {
  padding: 4px 0;
}

.popover-title {
  font-weight: bolder;
  font-size: 14px;
  margin-bottom: 12px;
  color: #333;
}

.detail-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 13px;
}

.detail-item-sub {
  padding-left: 16px;
  font-size: 12px;
  color: #666;
}

.detail-label {
  color: #666;
  flex-shrink: 0;
}

.detail-value {
  color: #333;
  font-weight: 500;
  margin-left: 8px;
}

.data-description {
  margin-top: 32px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
}

.description-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.description-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.description-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.description-item:hover {
  background: #e9ecef;
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #dee2e6;
}

.description-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 6px;
  margin-right: 12px;
}

.description-dot.blue {
  background: #2196f3;
}

.description-dot.green {
  background: #4caf50;
}

.description-dot.yellow {
  background: #ffc107;
}

.description-dot.purple {
  background: #9c27b0;
}

.description-dot.red {
  background: #f44336;
}

.description-dot.blue-light {
  background: #03a9f4;
}

.description-dot.pink {
  background: #e91e63;
}

.description-dot.teal {
  background: #009688;
}

.description-content {
  flex: 1;
}

.description-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  line-height: 1.4;
}

.description-text {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .calendar-day {
    padding: 10px 5px;
    min-height: 60px;
  }

  .day-number {
    font-size: 16px;
  }

  .week-day-header {
    padding: 10px 5px;
    font-size: 12px;
  }

  .description-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .description-item {
    padding: 12px;
  }
}
</style>